import React, { FC } from 'react';
import { graphql } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import Layout, { Head, Section } from 'components/Layout';

import HeroText from 'components/HeroText';
import HomeAnimation from 'components/HomeAnimation';
import EntitledSection from 'components/EntitledSection';
import Portfolio from 'components/Portfolio';
import { Watermark } from 'components/UI';

import {
  IAllContentfulHomeBlock,
  IContentfulHomeBlock,
  IAllContentfulPortfolioItem,
} from 'types';

interface IProps {
  data: {
    homeData: IAllContentfulHomeBlock;
    portfolioData: IAllContentfulPortfolioItem;
  };
}

const HomePage: FC<IProps> = ({
  data,
}) => {
  const { homeData, portfolioData } = data;
  const { nodes = [] } = homeData;

  const portfolioPageContext = {
    currentPage: 1,
    totalPages: 1,
    limit: 12,
    skip: 0,
  };

  return (
    <Layout>
      <Head title="Home" />

      <Section isFullscreen isCentered>
        <HeroText
          title={(
            <HomeAnimation
              lines={[
                'Data science.',
                'Global focus.',
                'Full life cycle.',
              ]}
            />
          )}
        />
      </Section>

      {nodes.map(({ title, text: { raw } }: IContentfulHomeBlock, index: number) => (
        <EntitledSection
          key={title}
          isDark={index % 2 === 0}
          title={title}
        >
          <div>
            {documentToReactComponents(JSON.parse(raw))}
          </div>
        </EntitledSection>
      ))}

      <Section>
        <Watermark />
        <Portfolio
          isPreview
          title="Private portfolio"
          data={{ portfolioData }}
          pageContext={portfolioPageContext}
        />
      </Section>

    </Layout>
  );
};

export const query = graphql`
  query HomePageQuery {
    homeData: allContentfulHomeBlock(
      sort: { fields: order, order: ASC }
    ) {
      nodes {
        title
        text {
          raw
        }
      }
    }
    portfolioData: allContentfulPortfolioItem(
      sort: { fields: title, order: ASC }
      limit: 24,
    ) {
      nodes {
        title
        text
        logo {
          file {
            url
          }
        }
      }
    }
  }
`;

export default HomePage;
